import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var mq = "@media screen and (".concat(componentTheme.phoneBreakPoint, ")");
  var orientVertically = props.stimulus.orientation === 'top';
  var connectingLines = {
    flex: '0 0 1rem',
    borderLeft: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
    borderBottom: "".concat(componentTheme.phoneConnectingLinesBorderWidth, " dotted"),
    borderColor: componentTheme.phoneConnectingLinesBorderColor,
    marginrTop: componentTheme.phoneConnectingLinesMargin,
    marginRight: componentTheme.phoneConnectingLinesMargin,
    height: '2rem',
    width: '1.5rem'
  };
  return {
    root: {
      borderTop: "".concat(componentTheme.rootBorderWidth, " solid ").concat(componentTheme.rootBorderColor),
      overflow: 'hidden'
    },
    instructions: _defineProperty({
      padding: "".concat(componentTheme.instructionsPaddingTopBottom, " ").concat(componentTheme.instructionsPaddingLeftRight),
      border: "".concat(componentTheme.instructionsBorderWidth, " solid ").concat(componentTheme.instructionsBorderColor)
    }, mq, {
      padding: "".concat(componentTheme.phoneInstructionsPaddingTopBottom, " ").concat(componentTheme.phoneInstructionsPaddingLeftRight)
    }),
    instructionsHeader: {
      paddingBottom: componentTheme.instructionsHeaderPadding,
      fontWeight: componentTheme.instructionsHeaderFontWeight
    },
    info: _defineProperty({
      padding: "".concat(componentTheme.infoPaddingTopBottom, " ").concat(componentTheme.infoPaddingLeftRight),
      height: '100%'
    }, mq, {
      padding: componentTheme.phoneInfoPadding
    }),
    header: {
      paddingTop: componentTheme.headerPaddingTop,
      paddingBottom: componentTheme.headerPaddingBottom
    },
    title: {
      fontSize: componentTheme.titleFontSize,
      fontWeight: componentTheme.titleFontWeight
    },
    item: {
      display: 'flex'
    },
    items: _objectSpread(_objectSpread({
      padding: componentTheme.itemsPadding,
      width: '50%'
    }, orientVertically && {
      width: '100%'
    }), {}, _defineProperty({}, mq, {
      width: '100%'
    })),
    stimulusItem: {
      flex: '1 1 auto',
      width: '100%'
    },
    stimulusGroup: _objectSpread(_objectSpread({
      display: 'flex',
      flexDirection: 'row'
    }, orientVertically && {
      flexDirection: 'column'
    }), {}, _defineProperty({}, mq, {
      flexDirection: 'column'
    })),
    stimulusInfo: _objectSpread(_objectSpread({
      width: '50%'
    }, orientVertically && {
      width: '100%'
    }), {}, _defineProperty({}, mq, {
      width: '100%'
    })),
    connectingLines: _objectSpread(_objectSpread({}, orientVertically && connectingLines), {}, _defineProperty({}, mq, connectingLines))
  };
};
export default generateStyle;